import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = ({ onAuth }) => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await axios.post(
          "/auth/emergent/session",
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        const user = res.data.user;
        const token = res.data.session_token;
        if (onAuth) onAuth(token, user);
        toast.success(`Welcome ${user?.name || ""}!`);
        const dest = user?.role === "admin" ? "/admin" : "/";
        navigate(dest, { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, onAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
    </div>
  );
};

export default AuthCallback;
